import api from "@/router/api";

export default {
  async gerarPinCode(emailOuCpf) {
    const response = await api.post("/controle-acesso/generate", {
      emailOrCpf: emailOuCpf,
    });
    return response.data || response;
  },

  async validarPinCode(data) {
    const response = await api.post("/controle-acesso/valid", data);
    return response.status;
  },

  async recuperarSenha(email) {
    const response = await api.post("/recuperacao-senha", {
      email: email ? email.trim() : email,
    });
    return response;
  },

  async redefinirSenha(payload) {
    const { token, senha } = payload;
    const tokenLimpo = token ? String(token).trim() : "";
    const response = await api.post(`/recuperacao-senha/${tokenLimpo}`, {
      novaSenha: senha,
    });
    return response;
  },
};
